exports = module.exports = require("../../../../../../emailtemplates/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ck-content .image>figcaption{display:table-caption;caption-side:bottom;word-break:break-word;color:#333;background-color:#f7f7f7;padding:.6em;font-size:.75em;outline-offset:-1px}", ""]);

// exports
